import { create } from 'zustand';

import { PaymentFormData } from '../types/payment-form-data.type';

type PendingPaymentState = {
    paymentId: number | null;
    intentId: string | null;
    userId: number | null;
    subscriptionIds: number[] | null;
    step1Payload: PaymentFormData | null;

    setPendingPayment: (data: {
        paymentId: number;
        intentId: string;
        userId: number;
        subscriptionIds: number[];
        step1Payload: PaymentFormData;
    }) => void;

    clearPendingPayment: () => void;
};

const initialState = {
    paymentId: null,
    intentId: null,
    userId: null,
    subscriptionIds: null,
    step1Payload: null,
};

export const usePendingPaymentStore = create<PendingPaymentState>((set) => ({
    ...initialState,

    setPendingPayment: ({
        paymentId,
        intentId,
        userId,
        subscriptionIds,
        step1Payload,
    }) => set({ paymentId, intentId, userId, subscriptionIds, step1Payload }),

    clearPendingPayment: () => set(initialState),
}));
